import React, { useEffect, useRef, useState } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../../../styles/select-style'
import axios from '../../../../../config/axios'
import { X } from 'lucide-react'

interface CompanyItemType {
  id: number
  companyName: string
  cnpj: string
  contactName?: string
  isMain?: boolean
  tipoEstabelecimento?: string
}

interface PropsType {
  suppliers: CompanyItemType[]
  setSuppliers: React.Dispatch<React.SetStateAction<CompanyItemType[]>>
  hideLabel?: boolean
  inputStyle?: React.CSSProperties
}

const SelectSupplierInResource:React.FC<PropsType> = ({
  suppliers,
  setSuppliers,
  hideLabel = false,
  inputStyle,
}) => {
  const [ items, setItems ] = useState<CompanyItemType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)

  const getLabelMain = (item: CompanyItemType): string => {
    if (!item) return '';
    if (!item.isMain) return '';
    const tipo = item.tipoEstabelecimento || (item.cnpj ? (item.cnpj.replace(/\D/g, '').substring(8, 12) === '0001' ? 'Matriz' : 'Filial') : '');
    return tipo ? ` - ${tipo}` : '';
  };
  
  useEffect(() => {
    setInputItem('')
  }, [])
  
  useEffect(() => {
    setSelectedIndex(0)
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`, {
      params: {
        query: inputItem,
        companyType: 'Fornecedor'
      }
    })
      .then(response => {
        if(response.data) setItems(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [inputItem])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: CompanyItemType) => {
    setInputItem('')
    setShowOptions(false)
    setSuppliers(prev => suppliers.some(s => s.id === item.id) ? prev : [...prev, item])
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  const handleRemoveSupplier = (id: number) => {
    setSuppliers(prev => prev.filter(s => s.id !== id))
  }

  return(
    <InputDiv>
      {!hideLabel && <Label>Fornecedor</Label>}
      <div style={{ position: 'relative', width: '100%' }}>
        <Input 
          ref={inputRef}
          type='text' 
          placeholder='Selecione'
          value={inputItem}
          onFocus={() => setShowOptions(true)}
          onChange={handleChangeInput}
          onKeyDown={(e) => handleSetOptionByKey(e)}
          style={inputStyle}
        />
        {showOptions && 
          <SearchOptions ref={optionsRef} style={{ top: 'calc(100% + 4px)' }}>
            {items.map((s, index) => 
              <Option 
                key={index}
                onClick={() => handleSelectItem(s)}
                isSelected={index === selectedIndex}
              >
                {(s.companyName || s.contactName || '') + getLabelMain(s)}
              </Option>
            )}
          </SearchOptions>
        }
      </div>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
        {suppliers.map((supplier) => (
          <div
            key={supplier.id} 
            style={{ backgroundColor: '#fff',
            padding: '5px 10px', 
            borderRadius: '1rem', 
            fontSize: '14px', 
            fontWeight: '400', 
            color: '#696969', 
            border: '1px solid #C4C4C4',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
            }}>
            {(supplier.companyName || supplier.contactName || '') + getLabelMain(supplier)}
            <X size={16} style={{ cursor: 'pointer' }} onClick={() => handleRemoveSupplier(supplier.id)} />
          </div>
        ))}
      </div>
    </InputDiv>
  )
}

export default SelectSupplierInResource

